import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ArrowUpIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M13.204 4.57017L23.4783 15.7982C24.1739 16.5 24.1739 17.7281 23.4783 18.4298C22.8361 19.1901 21.7124 19.1901 21.0702 18.4298L12.0268 8.54678L2.92977 18.4298C2.28763 19.1901 1.16388 19.1901 0.521739 18.4298C-0.173913 17.7281 -0.173913 16.5 0.521739 15.7982L10.796 4.57017C11.4381 3.80994 12.5619 3.80994 13.204 4.57017Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ArrowUpIcon
